import { useCurrentUser } from "../../../providers/CurrentUserProvider";
import { useEffect, useState } from "react";
import {
    Box,
    Button,
    CircularProgress,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    useTheme
} from "@mui/material";
import { T } from "../../../util/t";
import { Close } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import { useIsMobile } from "../../../../hooks/useIsMobile";

const customCss = theme => `
#form_container {
  background-color: ${theme.palette.background.low};
}
#minimize_form_button {
  color: ${theme.palette.primary.main};
}
#submit_form_button {
  background-color: ${theme.palette.primary.main};
  border-radius: ${theme.spacing(1)};
  color: ${theme.palette.primary.contrastText};
}
#submit_form_button:disabled {
  opacity: .6;
}
#submit_form_button:hover {
  opacity: .8;
}
.btn-outline {
  border: 1px solid ${theme.palette.border.main};
  border-radius: ${theme.spacing(1)};
  color: ${theme.palette.text.primary};
}
.btn-outline:hover {
  opacity: .9;
  border: 1px solid ${theme.palette.border.main};
  background-color: ${theme.palette.state.action};
  color: ${theme.palette.text.primary};
}
.btn-ghost {
  color: ${theme.palette.text.primary};
}
.btn-ghost:hover {
  background-color: ${theme.palette.state.action};
  opacity: .9;
  color: ${theme.palette.text.primary};
}
`;

export const SignatureDialogContent = ({ property, isSeriesRegistration, athlete, closeDialog, onChange }) => {
    const { currentUser: { email: userEmail } } = useCurrentUser();
    const [Docuseal, setDocuseal] = useState();
    const theme = useTheme();
    const params = useParams();
    const isMobile = useIsMobile();
    const payableParams = isSeriesRegistration ? `payable_type=Season&payable_id=${params.seriesId}` : `payable_type=Event&payable_id=${params.id}`;

    useEffect(() => {
        import(/* webpackChunkName: "docuseal" */ "@docuseal/react").then(docuseal => setDocuseal(docuseal));
    }, []);

    const externalId = `${property.uuid}-${userEmail}-${athlete.id || athlete.name?.toLowerCase()}`;

    const setValue = submission_id => onChange(`${window.location.origin}/api/long_running/documents/${submission_id}?${payableParams}`);
    const onSignatureCompleted = data => {
        setValue(data.submission_id);
        closeDialog();
    };
    const onLoad = data => {
        if (!!data.completed_submitter)
            setValue(data.completed_submitter.submission_id);
    };

    return (
        <>
            <DialogTitle display="flex" alignItems="center" justifyContent="space-between">
                <Typography variant="h6" component="p"><T>View and sign</T></Typography>
                <IconButton color="inherit" size="small" onClick={closeDialog}><Close/></IconButton>
            </DialogTitle>
            <DialogContent id="signature-dialog" sx={{ padding: 0 }}>
                {!Docuseal ?
                    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                        <CircularProgress size={60}/>
                    </Box> :
                    <Docuseal.DocusealForm
                        src={`https://docuseal.co/d/${property.config.docusealTemplateSlug}`}
                        email={userEmail}
                        externalId={externalId}
                        onComplete={onSignatureCompleted}
                        onLoad={onLoad}
                        customCss={customCss(theme)}
                    />
                }
            </DialogContent>
            {!isMobile &&
            <Box component={DialogActions} justifyContent="flex-start">
                <Button variant="outlined" onClick={closeDialog}>
                    <T>Close</T>
                </Button>
            </Box>}
        </>
    );
};
